import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { BLOGS, CASES } from "@/data/content";

export default function ArticleDetail({ kind }) {
  const { slug } = useParams();
  const navigate = useNavigate();
  const isCase = kind === "case";
  const list = isCase ? CASES : BLOGS;
  const item = list.find((x) => x.slug === slug);

  if (!item) {
    return (
      <main className="bg-[#FDFBF7] min-h-screen">
        <Navbar />
        <div className="pt-48 text-center pb-40">
          <p className="font-serif text-3xl">Not found.</p>
          <button onClick={() => navigate(-1)} className="mt-6 text-xs uppercase tracking-[0.2em] link-underline">Go back</button>
        </div>
        <Footer />
      </main>
    );
  }

  return (
    <main className="bg-[#FDFBF7] min-h-screen" data-testid="article-detail">
      <Navbar />
      <article className="pt-36 md:pt-44 pb-24">
        <div className="max-w-[820px] mx-auto px-6 md:px-10">
          <button
            onClick={() => navigate(isCase ? "/case-studies" : "/blogs")}
            data-testid="article-back"
            className="group inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#78716C] mb-10"
          >
            <ArrowLeft size={15} className="group-hover:-translate-x-1 transition-transform" />
            Back
          </button>
          <p className="text-[11px] uppercase tracking-[0.25em] text-[#C5A059] mb-5">
            {item.tag} · {item.date}{item.read ? ` · ${item.read}` : ""}
          </p>
          <h1 className="font-serif font-light text-4xl md:text-6xl tracking-tight leading-[0.98]">
            {item.title}
          </h1>
        </div>

        <div className="max-w-[1100px] mx-auto px-6 md:px-10 mt-12">
          <img src={item.img} alt={item.title} className="w-full h-auto" />
        </div>

        {isCase && (
          <div className="max-w-[820px] mx-auto px-6 md:px-10 mt-12 grid grid-cols-3 gap-6 border-y border-[#E8E4D9] py-8">
            {item.metrics.map(([n, l]) => (
              <div key={l}>
                <div className="font-serif text-4xl text-[#8a6d2f]">{n}</div>
                <div className="text-[11px] text-[#78716C] uppercase tracking-wide mt-1">{l}</div>
              </div>
            ))}
          </div>
        )}

        <div className="max-w-[820px] mx-auto px-6 md:px-10 mt-12 space-y-7">
          {item.body.map((p, i) => {
            if (p.startsWith("## ")) {
              return (
                <h2 key={i} className="font-serif text-3xl md:text-4xl tracking-tight text-[#1A1713] pt-6">
                  {p.slice(3)}
                </h2>
              );
            }
            if (p.startsWith("- ")) {
              return (
                <div key={i} className="flex gap-4 pl-1">
                  <span className="text-[#C5A059] mt-1.5 shrink-0">✦</span>
                  <p className="text-lg md:text-xl text-[#1A1713]/80 leading-relaxed font-serif">
                    {p.slice(2)}
                  </p>
                </div>
              );
            }
            return (
              <p key={i} className="text-lg md:text-xl text-[#1A1713]/80 leading-relaxed font-serif">
                {p}
              </p>
            );
          })}
        </div>
      </article>
      <Footer />
    </main>
  );
}
